import React from "react"
import type { ArtifactKind, ArtifactTemplateProps } from "connected-components/dashboard/modules/ai-artifact/types"
import PlotTemplate from "./plot"
import TableTemplate from "./table"

interface TemplateDefinition {
  Component: React.ComponentType<ArtifactTemplateProps>
}

const ARTIFACT_TEMPLATES: Record<ArtifactKind, TemplateDefinition> = {
  plot: { Component: PlotTemplate },
  table: { Component: TableTemplate },
}

export function getArtifactTemplate(kind: ArtifactKind): TemplateDefinition | undefined {
  return ARTIFACT_TEMPLATES[kind]
}
